
import {Component, EventEmitter, Output, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';
import {
  ADDRESS_PATTERN,
  PERSON_NAME_PATTERN,
  POSTAL_PATTERN
} from '../../../../_constants/constants';

@Component({
    selector: 'app-dirs-subject-form',
    templateUrl: './dirs-subject-form.component.html',
    styleUrls: ['./dirs-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent]
})
export class DirsSubjectFormComponent {

  @Output() submittedData = new EventEmitter<UntypedFormGroup>();
  @Output() back = new EventEmitter<void>();

  subjectFormGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;

  protected readonly formBuilder = inject(UntypedFormBuilder);

  constructor() {
    this.subjectFormGroup = this.formBuilder.group({
      firstName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(16),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])],
      middleName: ['', Validators.compose([
        Validators.maxLength(10),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(20),
        Validators.pattern(PERSON_NAME_PATTERN)
      ])]
    });

    this.addressFormGroup =
      StandardSubjectFormComponent.buildAddressFormGroup(this.formBuilder, {
        streetNum: ['', Validators.compose([
          Validators.maxLength(8),
          Validators.pattern(ADDRESS_PATTERN)
        ])],
        apartmentNum: ['', Validators.compose([
          Validators.maxLength(6),
          Validators.pattern(ADDRESS_PATTERN)
        ])],
        street: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(24),
          Validators.pattern(ADDRESS_PATTERN)
        ])],
        city: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(16),
          Validators.pattern(ADDRESS_PATTERN)
        ])],
        postalCode: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(6),
          Validators.pattern(POSTAL_PATTERN)
        ])]
      });
  }
}
